function positionGridCards() {
    const gridContainer = document.querySelector('.product-list [class*="grid"]');
    if (!gridContainer) return;

    const gridCards = Array.from(gridContainer.querySelectorAll('[data-grid-card]'));

    // Sort grid cards by position (lowest first)
    gridCards.sort((a, b) => {
        const posA = parseInt(a.dataset.gridPosition) || 0;
        const posB = parseInt(b.dataset.gridPosition) || 0;
        return posA - posB;
    });

    gridCards.forEach(card => {
        const targetPosition = parseInt(card.dataset.gridPosition) || 0;

        if (targetPosition === 0) return; // Stay at end

        const targetProduct = gridContainer.querySelector(`[data-position="${targetPosition}"]`);

        if (targetProduct) {
            // Insert grid card before the target product
            gridContainer.insertBefore(card, targetProduct);
        }
    });
}

// Run on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionGridCards);
} else {
    positionGridCards();
}

// Re-run after AJAX updates (filters, etc)
document.addEventListener('shopify:section:load', positionGridCards);
if (window.ThemeBus) {
    window.ThemeBus.addEventListener(window.EVENTS?.gridUpdated || 'grid:updated', positionGridCards);
}
